







import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import * as calc from '@/app/invoice-calculations-interface';
import * as calcWithOverdue from '@/app/invoice-with-overdue-notice-calculations-interface';
import DocumentSummary from '../Shared/DocumentSummary.vue';
import { DocumentShowType } from '../Shared/DocumentHeader.vue';
import { GQL_invoice_invoice } from '@/queries/__generated__/invoice';

@Component({
  components: {
    DocumentSummary,
  },
})
export default class InvoiceSummary extends Vue {
  @Prop(Object) public invoice!: GQL_invoice_invoice;
  @Inject() public documentShowType!: DocumentShowType;

  public taxSubtotals: calc.IInvoiceTaxSubtotal[] = [];

  public created() {
    if (!this.invoice.id) {
      // if this is a new invoice, calculate all the amounts
      this.calculateNewInvoice();
    } else if (this.documentShowType === 'overdueNotice') {
      this.calculateInvoiceWithOverdueNotices();
    }
    else {
      this.calculateExistingInvoice();
    }
  }

  private calculateNewInvoice() {
    const invoice = this.invoice as unknown as calc.IInvoice;

    this.invoice.lineExtensionAmount = calc.invoiceLineExtensionAmount(invoice);
    this.invoice.taxExclusiveAmount = calc.invoiceTaxExclusiveAmount(invoice);
    this.calculateTaxSubtotals();
    this.invoice.taxAmount = calc.invoiceTaxAmount(this.taxSubtotals);
    this.invoice.taxInclusiveAmount = calc.invoiceTaxInclusiveAmount(invoice);
    const rounding = this.invoice.unit.unitSetting.unitInvoiceSetting.taxInclusiveAmountRounding;
    this.invoice.payableRoundingAmount = calc.invoiceRoundingAmount(invoice, rounding);
    this.invoice.payableAmount = calc.invoicePayableAmount(invoice);
  }

  private calculateExistingInvoice() {
    // if the invoice is saved we dont want to recalcualte the amounts
    // we want to display the amounts that are stored in db
    // we only don't store tax subtotals, so these we have to calculate
    this.calculateTaxSubtotals();
  }

  private calculateInvoiceWithOverdueNotices() {
    const invoice = this.invoice as unknown as calc.IInvoice;
    this.calculateTaxSubtotals();

    this.invoice.taxExclusiveAmount = calcWithOverdue.invoiceTaxExclusiveAmount(invoice);
    this.invoice.taxInclusiveAmount = calc.invoiceTaxInclusiveAmount(invoice);
    // do not calculate payableRoundingAmount here
    this.invoice.payableAmount = calc.invoicePayableAmount(invoice);
  }

  private calculateTaxSubtotals() {
    const invoice = this.invoice as unknown as calc.IInvoice;
    const calculation = this.documentShowType === 'overdueNotice' ? calcWithOverdue : calc;
    this.taxSubtotals = calculation
      .invoiceTaxSubtotals(invoice)
      .sort((a, b) => a.taxPercent.sub(b.taxPercent).toNumber());
  }
}
